import Cookie from 'js-cookie';

import { Config } from '@nw/shared/config';

import {
  getCookie,
  getCookieAttrubutes,
  setCookie
} from '../AccountsStorageUtils';

const PAYMENT_ACCESS_TOKEN_KEY = 'QzSAqQAdqk';
const PAYMENT_REFRESH_TOKEN_KEY = 'MIuSiNUIRj';

export function setPaymentsRefreshTokenToDomain(
  refreshToken: string,
  expiryInDays = 30
) {
  setCookie(
    PAYMENT_REFRESH_TOKEN_KEY,
    refreshToken,
    expiryInDays,
    Config['APP_AUTH_COOKIE_DOMAIN']
  );
}

export function setPaymentsAccessTokenToDomain(
  accessToken: string,
  expiryInDays = 30
) {
  setCookie(
    PAYMENT_ACCESS_TOKEN_KEY,
    accessToken,
    expiryInDays,
    Config['APP_AUTH_COOKIE_DOMAIN']
  );
}

export function getPaymentRefreshToken() {
  return getCookie(PAYMENT_REFRESH_TOKEN_KEY);
}
export const isPaymentEnabled = (): boolean => {
  return Config['ENABLE_PAYMENTS'] === '1' ? true : false;
};

export function getPaymentAccessToken(): string {
  return isPaymentEnabled() ? getCookie(PAYMENT_ACCESS_TOKEN_KEY) : '';
}

export const clearPaymentsAccessToken = (domain?: string) => {
  Cookie.remove(PAYMENT_ACCESS_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

export const clearPaymentsRefreshToken = (domain?: string) => {
  Cookie.remove(PAYMENT_REFRESH_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

export const clearPaymentsAuthDomainTokens = () => {
  const appCookieDomain =
    Config['APP_COOKIE_DOMAIN'] || Config['APP_AUTH_COOKIE_DOMAIN'];
  if (appCookieDomain) {
    clearPaymentsAccessToken(appCookieDomain);
    clearPaymentsRefreshToken(appCookieDomain);
  }
};
